// extracted by mini-css-extract-plugin
module.exports = {"input":"JobLeft_input__3_Bce","info":"JobLeft_info__k2-EV"};